export default "__VITE_PUBLIC_ASSET__ba1d71b5__"